import { atom } from "recoil";
import { IEmployeeReportsTo } from "../types";

export const addStateEmployeeReportsTo = atom({
  key: "addStateEmployeeReportsTo",
  default: false,
});
export const editStateEmployeeReportsTo = atom({
  key: "editStateEmployeeReportsTo",
  default: false,
});
export const rowEditEmployeeReportsTo = atom<IEmployeeReportsTo | undefined>({
  key: "rowEditEmployeeReportsTo",
  default: undefined,
});

export const selectedRowsStateEmployeeReportsTo = atom<IEmployeeReportsTo[]>({
  key: "selectedRowsStateEmployeeReportsTo",
  default: [],
});

export const employeeReportsToFilterText = atom({
  key: "employeeReportsToFilterText",
  default: "",
});

export const employeeReportsToFetching = atom({
  key: "employeeReportsToFetching",
  default: true,
});
export const employeeReportsToReFetching = atom({
  key: "employeeReportsToReFetching",
  default: false,
});
